import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import { fileTextO } from 'react-icons-kit/fa/fileTextO';

import Pagination from 'components/Pagination/Pagination';
import ActionButton from 'components/ActionButton/ActionButton';

import Utils from 'utils/Utils';

import './Results.css';

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      activePage: 0,
      rowLimit: 7,
      order: 'date',
      asc: true,
      selected: {},
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.sortResults(nextProps.results, this.state.order);
  }

  sortResults = (results, order) => {
    const newResults = Utils.sortArrayByPropertyAndEquals(results, order, this.state.asc, 'title');
    this.setState({ results: newResults, activePage: 0, order: order });
  }

  changePage = (newPage) => {
    this.setState({ activePage: newPage });
  }

  showInfo = (data) => {
    const url = `${window.location.href.split('/catalogocartoteca/')[0]}/catalogocartoteca/info/${data.name}`;
    window.location.href = url;
  }

  render() {
    const { activePage, rowLimit, results } = this.state;
    const { searchOption } = this.props;
    let renderResults = [];
    let limit = rowLimit + rowLimit * activePage;
    if (limit > results.length) {
      limit = results.length;
    }

    let renderSubject = false;
    if (!renderSubject) {
      const allSubjects = [];
      results.forEach((r) => {
        if (allSubjects.indexOf(r.subject) === -1) {
          allSubjects.push(r.subject);
        }
      });

      renderSubject = allSubjects.length > 1;
    }

    if (results.length > 0) {
      for (let i = (rowLimit * activePage); i < limit; i++) {
        const r = results[i];
        let thumbnails = r.resources.filter((rr) => {
          return rr.resource_type === 'Miniatura';
        });

        let thumbnail = thumbnails[0];
        if (thumbnail === undefined) {
          thumbnails = r.resources.filter((rr) => {
            return rr.resource_type === 'PNG';
          });

          thumbnail = r.resources.filter((rr) => {
            return rr.resource_type === 'PNG';
          })[0];
        }

        renderResults.push(
          <tr key={'result' + r.id}>
            <td>
              { thumbnail !== undefined && thumbnails.length === 1 ?
                <div>
                  <img src={thumbnail.url} alt='Miniatura' />
                </div>
              : thumbnail !== undefined && thumbnails.length > 1 ?
                <div className='manyThumbnails'>
                  <img src={thumbnails[0].url} alt='Miniatura 1' />
                  <img src={thumbnails[1].url} alt='Miniatura 2' />
                </div>
              : null }
            </td>
            <td>
              <div className='tableRow'>
                <p onClick={this.showInfo.bind(null, r)}>{r.title}</p>
                <div>
                  <span>{r.date.substring(0, 4) !== '9999' && r.date.substring(0, 4) !== '19sa' ? r.date.substring(0, 4) : 'Desconocido'}</span>
                  <span>{r.map_creator}</span>
                  { renderSubject && searchOption !== 'cartografia-antigua' ?
                    <span>{r.subject}</span>
                  : null }
                </div>
              </div>
            </td>
            <td>
              <div>
                <ActionButton id={'resultInfo' + r.id} icon={fileTextO} size={'18px'}
                  color={'#006699'} text={'Ver ficha'} onClick={this.showInfo.bind(null, r)} />
              </div>
            </td>
          </tr>
        );
      }
    }

    return (
      <Fragment>
        <div className={'resultsContainer' + (results.length === 0 ? ' no-border' : '')}>
          { results.length > 0 ?
            <Fragment>
              <div className='table row'>
                <div className='tableContainer'>
                  <table>
                    <tbody>
                      { renderResults }
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='paginationContainer row' style={{ marginBottom: '20px' }}>
                <Pagination activePage={activePage} total={results.length}
                  rows={rowLimit} handlePageChange={this.changePage} />
              </div>
            </Fragment>
          : <div>
              <div className='resultsTitleContainer row'><span>{'No se han encontrado resultados'}</span></div>
            </div> }
        </div>
      </Fragment>
    );
  }
}

export default translate()(Results);
